import { memo } from "react"
import "../index.scss";
import CustomScroll from '@src/component/customScroll';
import moment from "moment";
import BottomIcon from "@src/component/bottomIcon";
import Store from "@src/util/store";

const StateSucc = (props: any) => {

  const phone = Store.get('phone').value;

  return (
    <div className="page bottomFit rzStatus">
      <CustomScroll>
        <div className="reFail">
          <div className="failIcon" />
          <div style={{width: 300,textAlign: 'center'}}>
            <p style={{width: '100%',margin: '5px 0'}}>抱歉，您当前{props.type?'分期申请':'资格预审'}未通过，暂无法向您提供金融服务</p>
            <span>您可在{moment(Number(props.assessTime)).add(props.type?30:60, 'days').format('yyyy-MM-DD')}重新发起申请</span>
          </div>
        </div>
      </CustomScroll>
      <footer>
        <p>若有疑问，请联系<span onClick={()=> {location.href = `tel:${phone as string}`}}>{phone}</span></p>
        <BottomIcon/>
      </footer>
    </div>

  )
}

export default memo(StateSucc);